import React from "react";
import PropTypes from "prop-types";
import { RequestStatusFormWrapper } from "./RequestStatusForm.styled";
import { getApprovalStatus } from "../../screens/lease/utils";

const SponsoredRequestStatus = ({ leaseData }) => {
	const requestStatus = leaseData?.usersRequest?.find((a) => a?.transactionId === leaseData?.objectId);

	const leaseStatus = getApprovalStatus(leaseData, requestStatus);

	return (
		<RequestStatusFormWrapper>
			<div className='statusFlow mt-4'>
				<div className={"statusFlow_item " + (leaseData?.firstPayment ? "done" : "")}>
					{leaseData?.firstPayment ? "First Payment Made" : "Awaiting First Payment"}
				</div>
				<div className={"statusFlow_item " + (leaseData?.leaseAgreement ? "done" : "")}>
					{leaseData?.leaseAgreement ? "Lease Agreement Signed" : "Awaiting Lease Agreement"}
				</div>
				<div className={"statusFlow_item " + (leaseStatus !== "pending" ? "done" : "")}>
					{leaseStatus === "pending"
						? "Awaiting approval from investor"
						: leaseStatus === "approved"
						? "Request approved"
						: leaseStatus === "rejected"
						? "Request rejected"
						: "Undecided"}
				</div>
				<div className={"statusFlow_item " + (leaseData?.paidSlots > 3 ? "done" : "")}>Asset Funded</div>
				<div className='statusFlow_item done'>Request Submitted</div>
				<div className='statusFlow_item done'>Credit Assessment</div>
				{leaseData?.guarantor && <div className='statusFlow_item done'>Awaiting Guarantor</div>}
				<div className='statusFlow_item done'>Auto Debit</div>
			</div>
		</RequestStatusFormWrapper>
	);
};

SponsoredRequestStatus.propTypes = {
	leaseData: PropTypes.object,
};

export default SponsoredRequestStatus;

export const ApprenticeSponsoredRequestStatus = ({ formData }) => {
	return (
		<RequestStatusFormWrapper>
			<div className='statusFlow mt-4'>
				<div className={"statusFlow_item " + (formData?.financeAgreement ? "done" : "")}>
					{formData?.financeAgreement ? "Finance Agreement Signed" : "Awaiting Finance Agreement"}
				</div>
				{formData?.requestType === "old" && (
					<div className={"statusFlow_item " + (formData?.commitmentFeeStatus === "paid" ? "done" : "")}>
						{formData?.commitmentFeeStatus === "paid"
							? "Commitement Fee Paid"
							: "Awaiting Commitment Fee Payment"}
					</div>
				)}
				{formData?.requestType === "old" && (
					<div className={"statusFlow_item " + (formData?.approvalStatus !== "pending" ? "done" : "")}>
						{formData?.approvalStatus === "approved"
							? "Finance request is accepted"
							: formData?.approvalStatus === "rejected"
							? "Finance request is rejected"
							: "Awaiting Approval from investor"}
					</div>
				)}
				{formData?.requestType === "new" && (
					<div className={"statusFlow_item " + (formData?.funded ? "done" : "")}>
						{formData?.funded ? "Finance Request has been Funded" : "Awaiting Request Funding"}
					</div>
				)}
				{formData?.requestType === "old" && (
					<div className={"statusFlow_item " + (formData?.investorFinanceInfo ? "done" : "")}>
						{formData?.investorFinanceInfo ? "Finance Request has been Funded" : "Awaiting Request Funding"}
					</div>
				)}
				{formData?.requestType === "new" && (
					<div className={"statusFlow_item " + (formData?.commitmentFeeStatus === "paid" ? "done" : "")}>
						{formData?.commitmentFeeStatus === "paid"
							? "Commitment Fee Paid"
							: "Awaiting Commitment Fee Payment"}
					</div>
				)}
				<div className='statusFlow_item done'>Request Submitted</div>
				<div className='statusFlow_item done'> Guarantor Information Submitted</div>
				<div className='statusFlow_item done'>Enabled Insurance</div>
				<div className='statusFlow_item done'>Auto Debit</div>
			</div>
		</RequestStatusFormWrapper>
	);
};

ApprenticeSponsoredRequestStatus.propTypes = {
	formData: PropTypes.object,
};
